// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lead-capture-form {
    align-self: flex-start;
    background-color: #f1f1f3;
    color: black;
    border-radius: 10px;
    padding: 20px 10px;
    margin: 0.2rem 0;
    width: 75%;
    max-width: 600px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-left: 7px;
}

.lead-capture-form form {
    display: flex;
    flex-direction: column;
}

.lead-capture-form .input-group {
    margin-bottom: 10px;
    /* Adjusted smaller margin between input groups */
}

.lead-capture-form label {
    display: block;
    margin-bottom: 3px;
    /* Reduced margin below labels */
    font-size: 12px;
    /* Slightly smaller font size for labels */
    font-weight: 600;
    color: #333;
}

.lead-capture-form input {
    width: 100%;
    padding: 8px 12px;
    /* Reduced padding inside inputs */
    border: 1px solid #ddd;
    border-radius: 12px;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
    font-weight: 550;
}

.lead-capture-form textarea {
    width: 95%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 12px;
    resize: vertical;
    min-height: 10px;
    font-family: 'Inter', sans-serif;
    font-weight: 550;
}

.lead-capture-form .form-buttons {
    display: flex;
    justify-content: center;
    margin-top: 5px;
    /* Slightly reduced top margin */
}

.lead-capture-form .submit-btn {
    background-color: #007aff;
    color: white; /* Text color */
    border: none;
    padding: 5px 10px; /* Adjust padding for better spacing */
    border-radius: 10px; /* Set border radius to 10px */
    cursor: pointer;
    font-size: 12px; /* Adjust font size as needed */
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center; /* Center items vertically */
    justify-content: center; /* Center items horizontally */
    height: auto; /* Allow height to adjust based on content */
}

.lead-capture-form .submit-btn:hover {
    background-color: #0056b3;
    transform: scale(1.05); /* Slightly enlarge on hover */
}

.lead-capture-form .submit-btn svg {
    margin-left: 5px; /* Space between text and icon */
    width: 16px; /* Adjust icon size as needed */
    height: 16px; /* Adjust icon size as needed */
    fill: white; /* Change icon color to white */
}

.lead-capture-form .close-btn {
    position: absolute;
    top: 10px;
    /* Adjusted to align with increased top padding */
    right: 10px;
    /* Adjusted for more space */
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    padding: 8px;
    /* Increased padding for a larger hit area */
    line-height: 1;
    width: 30px;
    /* Increased width */
    height: 30px;
    /* Increased height */
    display: flex;
    align-items: center;
    justify-content: center;
}

.lead-capture-form .close-btn:hover {
    color: #333;
}

.lead-capture-form .close-btn::before {
    content: "\\00d7";
}

/* Responsive design for smaller screens */
@media (max-width: 320px) {
    .lead-capture-form {
        width: 90%;
        /* Adjust for very small screens */
    }
}

.error-message {
    color: rgb(235, 3, 3); /* Red color for error messages */
    font-size: 12px; 
    margin-bottom: 5px; /* Space above the error message */
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/LeadCaptureForm/LeadCaptureForm.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,0CAA0C;IAC1C,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY,EAAE,eAAe;IAC7B,YAAY;IACZ,iBAAiB,EAAE,sCAAsC;IACzD,mBAAmB,EAAE,8BAA8B;IACnD,eAAe;IACf,eAAe,EAAE,+BAA+B;IAChD,gCAAgC;IAChC,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,mBAAmB,EAAE,4BAA4B;IACjD,uBAAuB,EAAE,8BAA8B;IACvD,YAAY,EAAE,4CAA4C;AAC9D;;AAEA;IACI,yBAAyB;IACzB,sBAAsB,EAAE,8BAA8B;AAC1D;;AAEA;IACI,gBAAgB,EAAE,gCAAgC;IAClD,WAAW,EAAE,+BAA+B;IAC5C,YAAY,EAAE,+BAA+B;IAC7C,WAAW,EAAE,+BAA+B;AAChD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iDAAiD;IACjD,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA,0CAA0C;AAC1C;IACI;QACI,UAAU;QACV,kCAAkC;IACtC;AACJ;;AAEA;IACI,qBAAqB,EAAE,iCAAiC;IACxD,eAAe;IACf,kBAAkB,EAAE,kCAAkC;IACtD,gBAAgB;AACpB","sourcesContent":[".lead-capture-form {\n    align-self: flex-start;\n    background-color: #f1f1f3;\n    color: black;\n    border-radius: 10px;\n    padding: 20px 10px;\n    margin: 0.2rem 0;\n    width: 75%;\n    max-width: 600px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    position: relative;\n    margin-left: 7px;\n}\n\n.lead-capture-form form {\n    display: flex;\n    flex-direction: column;\n}\n\n.lead-capture-form .input-group {\n    margin-bottom: 10px;\n    /* Adjusted smaller margin between input groups */\n}\n\n.lead-capture-form label {\n    display: block;\n    margin-bottom: 3px;\n    /* Reduced margin below labels */\n    font-size: 12px;\n    /* Slightly smaller font size for labels */\n    font-weight: 600;\n    color: #333;\n}\n\n.lead-capture-form input {\n    width: 100%;\n    padding: 8px 12px;\n    /* Reduced padding inside inputs */\n    border: 1px solid #ddd;\n    border-radius: 12px;\n    font-size: 14px;\n    font-family: 'Inter', sans-serif;\n    box-sizing: border-box;\n    font-weight: 550;\n}\n\n.lead-capture-form textarea {\n    width: 95%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 12px;\n    resize: vertical;\n    min-height: 10px;\n    font-family: 'Inter', sans-serif;\n    font-weight: 550;\n}\n\n.lead-capture-form .form-buttons {\n    display: flex;\n    justify-content: center;\n    margin-top: 5px;\n    /* Slightly reduced top margin */\n}\n\n.lead-capture-form .submit-btn {\n    background-color: #007aff;\n    color: white; /* Text color */\n    border: none;\n    padding: 5px 10px; /* Adjust padding for better spacing */\n    border-radius: 10px; /* Set border radius to 10px */\n    cursor: pointer;\n    font-size: 12px; /* Adjust font size as needed */\n    font-family: 'Inter', sans-serif;\n    font-weight: 500;\n    transition: background-color 0.3s ease;\n    display: flex;\n    align-items: center; /* Center items vertically */\n    justify-content: center; /* Center items horizontally */\n    height: auto; /* Allow height to adjust based on content */\n}\n\n.lead-capture-form .submit-btn:hover {\n    background-color: #0056b3;\n    transform: scale(1.05); /* Slightly enlarge on hover */\n}\n\n.lead-capture-form .submit-btn svg {\n    margin-left: 5px; /* Space between text and icon */\n    width: 16px; /* Adjust icon size as needed */\n    height: 16px; /* Adjust icon size as needed */\n    fill: white; /* Change icon color to white */\n}\n\n.lead-capture-form .close-btn {\n    position: absolute;\n    top: 10px;\n    /* Adjusted to align with increased top padding */\n    right: 10px;\n    /* Adjusted for more space */\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #999;\n    padding: 8px;\n    /* Increased padding for a larger hit area */\n    line-height: 1;\n    width: 30px;\n    /* Increased width */\n    height: 30px;\n    /* Increased height */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.lead-capture-form .close-btn:hover {\n    color: #333;\n}\n\n.lead-capture-form .close-btn::before {\n    content: \"\\00d7\";\n}\n\n/* Responsive design for smaller screens */\n@media (max-width: 320px) {\n    .lead-capture-form {\n        width: 90%;\n        /* Adjust for very small screens */\n    }\n}\n\n.error-message {\n    color: rgb(235, 3, 3); /* Red color for error messages */\n    font-size: 12px; \n    margin-bottom: 5px; /* Space above the error message */\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
